import { render } from "./ExecutiveDashboard.vue?vue&type=template&id=341b73ca&scoped=true"
import script from "./ExecutiveDashboard.vue?vue&type=script&lang=js"
export * from "./ExecutiveDashboard.vue?vue&type=script&lang=js"

import "./ExecutiveDashboard.vue?vue&type=style&index=0&id=341b73ca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341b73ca"]])

export default __exports__